module.exports = "https://www.gc-pro.gnp.com.mx/c0117c58498306f7a66570296258a9b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-document.svg
// module id = 972
// module chunks = 0